// KL - aircond chemical wash.
const content = {
    slug: 'aircond-chemical-wash',
    title: (c) => `Aircond Chemical Wash KL from ${c.money(c.tables.chemicalWash[0].wall)} | Remove Smell & Mould`,
    description: (c) =>
        `Aircond chemical wash in Kuala Lumpur from ${c.money(c.tables.chemicalWash[0].wall)}. Removes mould, smell and dirt from the coil and blower. Wall-mounted and cassette units.`,
    eyebrow: 'KL · Chemical wash',
    h1: 'Aircond Chemical Wash in Kuala Lumpur',
    lead: (c) =>
        `When your aircond smells musty, drips, or blows weak air even after a service, the coil needs chemicals, not just water. ${c.money(c.tables.chemicalWash[0].wall)} for one wall-mounted unit, ${c.money(c.tables.chemicalWash[2].wall)} for three.`,
    image: 'blog/living/dirty-aircon-evaporator-coil.jpg',
    imageAlt: 'Dirty aircond coil before a chemical wash in a KL condo',
    facts: ['Kills mould and smell', 'About 90 minutes per unit', 'Wall and cassette'],
    priceTitle: 'Chemical wash prices',
    priceIntro: (c) => `Wall-mounted units from ${c.money(c.tables.chemicalWash[0].wall)}. Ceiling cassettes from ${c.money(c.tables.chemicalWash[0].ducted)}.`,
    panel: { type: 'servicing', services: ['chemicalWash'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'Signs your aircond needs a chemical wash',
            items: [
                'A sour or musty smell ("aircond bau") when you switch it on.',
                'Black dots on the louvres or the front panel.',
                'Weak airflow even with a clean filter.',
                'Water dripping from the indoor unit.',
                'The room takes much longer to cool than it used to.',
                'You or your children wake up sneezing or congested.',
            ],
            columns: 2,
        },
        {
            title: 'Why mould loves KL aircond',
            tone: 'muted',
            paragraphs: [
                'In Malaysia\'s humidity, the coil inside your aircond is wet every time it runs - and in bedrooms that is most nights. Dust from the room sticks to the wet fins and turns into a sticky film. Mould grows on that film and on the curved blades of the blower wheel, where the air rushes past on its way to you.',
                'Water alone doesn\'t shift that film. The chemical wash uses a coil cleaner that dissolves it, then rinses everything off, so the coil can breathe and the smell goes with the dirt.',
            ],
        },
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'How the chemical wash is done',
            steps: [
                { title: 'Cover and protect', body: 'A wash bag goes over the unit to catch water and dirt; the wall and bed below are covered.' },
                { title: 'Chemical applied', body: 'Coil cleaner is sprayed onto the coil and left to work on the grime.' },
                { title: 'Pressure rinse', body: 'The coil and blower wheel are rinsed with a low-pressure jet until the water runs clear.' },
                { title: 'Drain flushed', body: 'The drain tray and pipe are flushed so the dirty water leaves properly.' },
                { title: 'Test run', body: 'The unit runs for a few minutes and the outlet temperature is checked.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is an aircond chemical wash in KL?',
            answer: (c) => `${c.money(c.tables.chemicalWash[0].wall)} for one wall-mounted unit, ${c.money(c.tables.chemicalWash[1].wall)} for two and ${c.money(c.tables.chemicalWash[2].wall)} for three. Ceiling cassettes cost ${c.money(c.tables.chemicalWash[0].ducted)} per unit.`,
        },
        {
            question: 'Chemical wash or chemical overhaul?',
            answer: 'A chemical wash cleans the unit while it stays on the wall. An overhaul takes the unit down and washes every part separately - for units that haven\'t been serviced in years or still smell after a wash.',
        },
        {
            question: 'How often should I chemical wash my aircond?',
            answer: 'Once a year for most homes. Twice a year for units used every night, in ground-floor homes, or if someone at home has allergies.',
        },
        {
            question: 'Is it the same as "chemical service"?',
            answer: 'Yes. Malaysian shops use chemical wash, chemical service and chemical cleaning to mean the same job.',
        },
    ],
    schema: {
        name: 'Aircond Chemical Wash in Kuala Lumpur',
        serviceType: 'Air conditioner chemical cleaning',
        offers: (c) => [
            { name: 'Chemical wash, 1 unit', price: c.tables.chemicalWash[0].wall },
            { name: 'Chemical wash, 2 units', price: c.tables.chemicalWash[1].wall },
            { name: 'Chemical wash, 3 units', price: c.tables.chemicalWash[2].wall },
            { name: 'Chemical wash, 1 ceiling cassette', price: c.tables.chemicalWash[0].ducted },
        ],
    },
}

export default content
